import { Add } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import * as React from "react";
import { ToastContainer } from "react-toastify";
import AddTokenSecurityKeyDialog from "./AddTokenSecurityKeyDialog";
import TokenSecurityKey from "./TokenSecurityKey";
import DeleteCdnJwtKeyDialog from "./DeleteCdnJwtKeyDialog";

interface Props {
    channelId: string;
    parentChannelId: string;
    organizationId: string;
    keys: { id: string }[];
}

export default function TokenSecurityKeysSection({
    channelId,
    organizationId,
    parentChannelId,
    keys,
}: Props): JSX.Element {
    const [openAddKeyDialog, setOpenAddKeyDialog] = React.useState<boolean>(false);
    const [openDeleteKeyDialog, setOpenDeleteKeyDialog] = React.useState<boolean>(false);
    const [selectedKey, setSelectedKey] = React.useState<string | undefined>(undefined);

    return (
        <>
            <Grid container spacing={4} alignItems={"center"}>
                {keys.map((key, i) => (
                    <Grid item key={`key-${i}`}>
                        <TokenSecurityKey
                            keyId={key.id}
                            onDeleteClick={() => {
                                setSelectedKey(key.id);
                                setOpenDeleteKeyDialog(true);
                            }}
                        />
                    </Grid>
                ))}
                {keys.length < 2 && (
                    <Grid item>
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            startIcon={<Add />}
                            onClick={() => setOpenAddKeyDialog(true)}
                        >
                            Add key
                        </Button>
                    </Grid>
                )}
            </Grid>
            <AddTokenSecurityKeyDialog
                onClose={() => setOpenAddKeyDialog(false)}
                open={openAddKeyDialog}
                aliasId={channelId}
                channelId={parentChannelId}
                organizationId={organizationId}
            />
            {selectedKey && (
                <DeleteCdnJwtKeyDialog
                    aliasId={channelId}
                    channelId={parentChannelId}
                    organizationId={organizationId}
                    keyId={selectedKey}
                    onClose={() => {
                        setOpenDeleteKeyDialog(false);
                        setSelectedKey(undefined);
                    }}
                    open={openDeleteKeyDialog}
                />
            )}

            <ToastContainer />
        </>
    );
}
